module.exports = __webpack_public_path__ + "media/images/testimonials-615d361570c2e1fe4e1794c6e68b6c69.jpg";